import { render, staticRenderFns } from "./BannerList.vue?vue&type=template&id=b42afb0c&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=ts"
export * from "./BannerList.vue?vue&type=script&lang=ts"
import style0 from "./BannerList.vue?vue&type=style&index=0&id=b42afb0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42afb0c",
  null
  
)

export default component.exports